/* eslint-disable @typescript-eslint/no-shadow */
import { selectPermissions, selectFolders } from 'common/selectors';
import { SelectForm } from 'features/common';
import React from 'react';
import { Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import T from 'i18n';

const MoveDocument = ({
  title,
  control,
  errors,
  canUnselect,
  autofocus,
  readOnly,
  currentFolderType,
  folderError,
  menuPosition,
  label,
  defaultFolderName,
  excludePublicContainers = false,
  excludeTrialBundles = false,
  ...rest
}) => {
  const folders = useSelector(selectFolders);
  const {
    folders: { canAddDocuments },
  } = useSelector(selectPermissions);
  const trialBundles = (folders.trialbooks || []).filter((folder) => canAddDocuments(folder));
  const courtBundles = (folders.courtBundles || []).filter((folder) => canAddDocuments(folder));
  const teamBundles = (folders.teamBundles || []).filter((folder) => canAddDocuments(folder));
  const privateBundles = (folders.privateBundles || []).filter((folder) => canAddDocuments(folder));

  const getDefaultValue = () => {
    if (defaultFolderName) return null;
    if (teamBundles.length > 0) return teamBundles[0].id || null;
    if (privateBundles.length > 0) return privateBundles[0].id || null;
    return null;
  };

  const getBooks = (books) =>
    books
      .filter((b) => !b.readOnly)
      .map((book) => {
        if (book.folders && book.folders.length > 0 && !book.readOnly) {
          return {
            label: book.name,
            options: getBooks(book.folders),
          };
        } else {
          return !book.readOnly && book;
        }
      });

  // If defaultFolderName is provided, add it as an option at the top
  const defaultFolderOption = defaultFolderName
    ? [
        {
          label: 'Default Team Bundle',
          options: [
            {
              id: 'auto-generated',
              name: defaultFolderName,
              readOnly: false,
            },
          ],
        },
      ]
    : [];

  const options = [
    ...defaultFolderOption,
    !excludePublicContainers &&
      !excludeTrialBundles &&
      trialBundles.length > 0 && {
        label: 'Trial Bundles',
        options: getBooks(trialBundles),
      },
    !excludePublicContainers &&
      courtBundles.length > 0 && {
        label: 'Court Bundles',
        options: getBooks(courtBundles),
      },
    teamBundles.length > 0 && {
      label: 'Team Bundles',
      options: getBooks(teamBundles),
    },
    privateBundles.length > 0 && {
      label: 'Private Bundles',
      options: getBooks(privateBundles),
    },
  ].filter(Boolean);

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <Form.Group>
        <SelectForm
          label={
            label || (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  marginRight: '1rem',
                }}
              >
                <span>{T.translate(title) || T.translate('case.folderToMoveTo')}</span>
              </div>
            )
          }
          fullWidthLabel={false}
          placeholder={T.translate('case.folderPlaceholder')}
          name="folder"
          {...(!defaultFolderName && { defaultValue: getDefaultValue() })}
          valueKey="id"
          labelKey="name"
          options={options}
          control={control}
          rules={{ required: !canUnselect }}
          onChange={undefined}
          isClearable={canUnselect}
          readOnly={readOnly}
          errors={errors}
          autofocus={autofocus}
          menuPosition={menuPosition || 'fixed'}
          menuPlacement={rest.menuPlacement || 'top'}
          {...rest}
        />
        {folderError && (
          <div style={{ color: 'red', marginTop: '5px', fontSize: '0.875rem' }}>{folderError}</div>
        )}
      </Form.Group>
    </Form>
  );
};

export default MoveDocument;
